export const animals = [
  'Saint Bernard',
  'Velociraptor',
  'Plankton',
  'Whale! 🐳',
  'Earwig',
  'Piranha',
  'Stinkbug',
  'Pigeon',
  'Milipede',
  'Boa constrictor',
  'skunk',
  'T Rex',
  '🐜 fire ants',
  'Mosquito',
  'Lobsters 🦞',
  'Puffer Fish',
  'Barracuda',
  'Flounder',
  'Siberian Tiger',
  `Other people's kids`,
  'Great White',
  'Sumatran Tiger',
  'Hedgehog',
  'Liger',
  'Dalmatian',
  'Hammerhead Shark',
  'Sumatran Elephant',
  'Yak',
  'Emperor Penguin',
  'Jaguar',
  'Cow',
  'Mandrill',
  'Horned Frog',
  'Grizzly Bear',
  'South China Tiger',
  'Beagle',
  'Emperor Tamarin',
  'Eastern Lowland Gorilla',
  'Cottontop Tamarin',
  'Carolina Dog',
  'Human',
  'Caiman Lizard',
  'Egyptian Mau',
  'Elephant Seal',
  'Red-handed Tamarin',
  'Tasmanian Devil',
  'Coyote',
  'Common Toad',
  'Bobcat',
  'Hermit Crab',
  'Sperm Whale',
  'Tiger Salamander',
  'Barb',
  'Horse',
  'Mastiff',
  'Havanese',
  'Vervet Monkey',
  'Falcon',
  'Prawn',
  'Coral',
  'Australian Cattle Dog',
  'Doberman Pinscher',
  'Burrowing Frog',
  'Snail',
  'Weasel',
  'Goat',
  'Donkey',
  'Galapagos Tortoise',
  'Blue Lacy Dog',
  'Boxer Dog',
  'African Tree Toad',
  'Giant Panda Bear',
  'Mountain Gorilla',
  'Yorkshire Terrier',
  'Moose',
  'Akita',
  'Balinese',
  'Brown Bear',
  'Kangaroo',
  'Kakapo',
  'Chihuahua',
  'Gila Monster',
  'Tropicbird',
  'Shrimp',
  'Platypus',
  'Golden Oriole',
  'Avocet',
  'Tortoise',
  'Fennec Fox',
  'Jellyfish',
  'Bull Mastiff',
  'Poison Dart Frog',
  'Spadefoot Toad',
  'Siberian',
  'Wombat',
  'Galapagos Penguin',
  'Budgerigar',
  'Royal Penguin',
  'Turkey',
  'Finnish Spitz',
  'Aldabra Giant Tortoise',
  'Rat',
  'Sloth',
  'Labrador Retriever',
  'Crab',
  'Macaroni Penguin',
  'Clouded Leopard',
  'Toucan',
  'King Penguin',
  'Ibizan Hound',
  'Drever',
  'Echidna',
  'Chow Chow',
  'Maine Coon',
  'River Dolphin',
  'Giraffe',
  'Ferret',
  'Sea Turtle',
  'Cat',
  'Asian Elephant',
  'Otter',
  'Bull Shark',
  'Gecko',
  'Barnacle',
  'African Wild Dog',
  'Magellanic Penguin',
  'Glass Lizard',
  'Purple Emperor',
  'Patas Monkey',
  'Butterfly',
  'Millipede',
  'Badger',
  'Cichlid',
  'Japanese Chin',
  'Birman',
  'Chimpanzee',
  'Himalayan',
  'Pond Skater',
  'Clown Fish',
  'Tiger',
  'Bonobo',
  'Dodo',
  'X-Ray Tetra',
  'Hercules Beetle',
  'Silver Dollar',
  'Somali',
  'Glow Worm',
  'Sand Lizard',
  'Guppy',
  'Porcupine',
  'Sheep',
  'American Pit Bull Terrier',
  'Burmese',
  'Grey Mouse Lemur',
  'White Tiger',
  'Adelie Penguin',
  'Quetzal',
  'Beetle',
  'Arctic Wolf',
  'Sponge',
  'Mule',
  'Kingfisher',
  'Water Vole',
  'Red Wolf',
  'Russian Blue',
  'Indian Elephant',
  'King Crab',
  'Dhole',
  'Sea Urchin',
  'Antelope',
  'Salamander',
  'Dwarf Crocodile',
  'Norfolk Terrier',
  'Capybara',
  'Radiated Tortoise',
  'Pika',
  'English Springer Spaniel',
  'Frog',
  'Malayan Tiger',
  'Snowy Owl',
  'Sea Lion',
  'Canaan Dog',
  'Kiwi',
  'Border Terrier',
  'Sun Bear',
  'Red Panda',
  'Serval',
  'Blue Whale',
  'Tree Frog',
  'Pied Tamarin',
  'Dunker',
  'Jackal',
  'Penguin',
  'Elephant Shrew',
  'Labradoodle',
  'Golden Retriever',
  'Fossa',
  'Monte Iberia Eleuth',
  'Manta Ray',
  'Geoffroys Tamarin',
  'Crane',
  'American Coonhound',
  'Little Penguin',
  'German Shepherd',
  'Seal',
  'Impala',
  'Indian Star Tortoise',
  'Giant Schnauzer',
  'Rabbit',
  'Quoll',
  'Cougar',
  'Quail',
  'Bumble Bee',
  'Asian Palm Civet',
  'Spectacled Bear',
  'Lynx',
  'Bongo',
  'Afghan Hound',
  'Giant African Land Snail',
  'African Palm Civet',
  'Whale Shark',
  'Sea Slug',
  'Bulldog',
  'Shih Tzu',
  'Ant',
  'Gar',
  'Booby',
  'Ocelot',
  'Pool Frog',
  'American Foxhound',
  'Arctic Fox',
  'Swan',
  'Buffalo',
  'Pelican',
  'Chinook',
  'Slow Worm',
  'Tiffany',
  'Numbat',
  'Anatolian Shepherd Dog',
  'Pheasant',
  'Beaver',
  'Basenji Dog',
  'Irish WolfHound',
  'Deer',
  'Pig',
  'Camel',
  'Dusky Dolphin',
  'Mayfly',
  'Panther',
  'Cuscus',
  'Dogue De Bordeaux',
  'Black Bear',
  'Flamingo',
  'Borneo Elephant',
  'Asian Giant Hornet',
  'Dachshund',
  'Banded Palm Civet',
  'Umbrellabird',
  'Rock Hyrax',
  'Long-Eared Owl',
  'Angelfish',
  'Horseshoe Crab',
  'Sri Lankan Elephant',
  'Entlebucher Mountain Dog',
  'Aardvark',
  'Tang',
  'Grey Reef Shark',
  'Turkish Angora',
  'Australian Terrier',
  'Rhinoceros',
  'Old English Sheepdog',
  'Mongrel',
  'Octopus',
  'Desert Tortoise',
  'Tetra',
  'Affenpinscher',
  'Asiatic Black Bear',
  'Snake',
  'White Rhinoceros',
  'German Pinscher',
  'Cairn Terrier',
  'Crested Penguin',
  'Bloodhound',
  'Gibbon',
  'Gopher',
  'Warthog',
  'Crocodile',
  'Chinese Crested Dog',
  'Green Bee-Eater',
  'Proboscis Monkey',
  'Moray Eel',
  'Water Dragon',
  'Mountain Lion',
  'Great Dane',
  'Siamese',
  'Marine Toad',
  'Wildebeest',
  'Monkey',
  'Chicken',
  'Fur Seal',
  'Barn Owl',
  'Rattlesnake',
  'Leopard Tortoise',
  'Ostrich',
  'Pointer',
  'Ibis',
  'Great White Shark',
  'Fox',
  'Leopard Cat',
  'Norwegian Forest',
  'Malayan Civet',
  'Jack Russel',
  'Sea Squirt',
  'Woolly Mammoth',
  'Moth',
  'Bullfrog',
  'Caterpillar',
  'Dugong',
  'Mouse',
  'Komodo Dragon',
  'Bengal Tiger'
]
